export const ENGRAVING_FONTS = [
  { id: "cinzel", label: "Cinzel · grabado clásico", css: "'Cinzel', serif",
    url: "https://cdn.jsdelivr.net/fontsource/fonts/cinzel@latest/latin-400-normal.woff" },
  { id: "playfair", label: "Playfair · serif elegante", css: "'Playfair Display', serif",
    url: "https://cdn.jsdelivr.net/fontsource/fonts/playfair-display@latest/latin-400-normal.woff" },
  { id: "dancing", label: "Dancing Script · cursiva", css: "'Dancing Script', cursive",
    url: "https://cdn.jsdelivr.net/fontsource/fonts/dancing-script@latest/latin-400-normal.woff" },
  { id: "montserrat", label: "Montserrat · moderna", css: "'Montserrat', sans-serif",
    url: "https://cdn.jsdelivr.net/fontsource/fonts/montserrat@latest/latin-400-normal.woff" },
];

export const fontById = (id) => ENGRAVING_FONTS.find((f) => f.id === id) || ENGRAVING_FONTS[0];

export const productFonts = (product) =>
  (product?.engraving_fonts || ["cinzel", "dancing"]).map(fontById).filter(Boolean);
